import { ScanLine, MonitorCog, Microscope } from "lucide-react";
import AnimatedSection from "@/components/common/AnimatedSection";
import PageHero from "@/components/common/PageHero";
import PageTransition from "@/components/layout/PageTransition";

const techItems = [
  {
    icon: ScanLine,
    title: "Digital X-rays",
    text: "Clear diagnostics with lower exposure support and precise treatment planning.",
  },
  {
    icon: MonitorCog,
    title: "Digital Impressions",
    text: "Comfortable and accurate impressions with Digital Scanner since 2019. Kavlekar Dental is the first to adopt this technology in north karnataka.",
  },
  {
    icon: Microscope,
    title: "Microscope-Assisted Dentistry",
    text: "Experience precision with our state-of-the-art Labomed Magna microscope. This high-end system offers unparalleled visibility and accuracy, enabling ultra-precise, minimally invasive procedures.",
  },
];

export default function TechnologyPage() {
  return (
    <PageTransition testId="technology-page">
      <PageHero
        title="Technology"
        subtitle="Modern systems that enhance clinical precision, treatment predictability, and patient comfort."
        image="https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&w=2000&q=80"
        testId="technology-page-hero"
      />

      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-24">
        <AnimatedSection testId="technology-items-section">
          <div className="grid gap-6 md:grid-cols-3">
            {techItems.map((item) => {
              const Icon = item.icon;
              return (
                <article
                  key={item.title}
                  className="rounded-2xl border border-[#f2e6c9] bg-[#fffdf8] p-6"
                  data-testid={`technology-card-${item.title
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  <Icon className="h-6 w-6 text-[#c5a059]" />
                  <h2
                    className="mt-3 font-[Playfair_Display] text-2xl text-[#1a1a1a]"
                    data-testid={`technology-card-title-${item.title
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {item.title}
                  </h2>
                  <p
                    className="mt-3 font-[Manrope] text-sm text-[#555555]"
                    data-testid={`technology-card-text-${item.title
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {item.text}
                  </p>
                </article>
              );
            })}
          </div>
        </AnimatedSection>
      </div>
    </PageTransition>
  );
}
